<template>
  <div id="responsibility">
    <v-card
      class="mx-auto"
      max-width="600"
      min-width="300"
      min-height="80"
      color="#f6f6fa"
    >
    <p style="color:#FFFFFF;background-color:#5555BB"><b>責任者</b></p>
    <div class="wait-immediate-area">
      <div v-if="isExecuter">
        <p>陰謀カードを1枚選択し，<br><span v-on:click="showEffect(5)" class="plot-name"><b><u>責任者</u></b></span>を使用して下さい．</p>
        <div class="assigning-table">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <div v-for="(user, userKey) in users" v-bind:key="user.id" >
                  <div v-if="user.plots.length>0">
                    <tr v-for="(plot, plotKey) in user.plots" v-bind:key="user.name+plot" >
                      <div v-if="user.id!=userId && !plot.done && (plot.id==1 || plot.id==2 || plot.id==3 || plot.id==4 || plot.id==9 )" class="background-color">
                        <td style="width:110px">
                          <div class="assign-button">
                            <pickButton v-if="isAssigned[userKey][plotKey]" v-on:pushed="assign(userKey,plotKey)" activeLabel="選択" active='true' />
                            <pickButton v-else v-on:pushed="assign(userKey,plotKey)" inactiveLabel="未選択" active='false' />
                          </div>
                        </td>
                        <!-- <td v-if="isAssigned[userKey][plotKey]" style="width:110px">
                          <v-btn v-on:click="assign(userKey,plotKey)" class="assign-button" large color="primary" min-width=80>選択</v-btn>
                        </td>
                        <td v-else style="width:110px">
                          <v-btn class="assign-button" v-on:click="assign(userKey,plotKey)" large color="primary" outlined max-width=80>未選択</v-btn>
                        </td> -->
                        <td style="width:180px">
                          <p><span class="user-label plot-name" v-on:click="showEffect(plot.id)"><b><u>{{ getPlotName(plot.id) }}</u></b></span><br><span> ({{ user.name }})</span></p>
                        </td>
                      </div>
                    </tr>
                  </div>
                </div>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div class="send-button">
          <sendButton v-if="canSend" v-on:pushed="push" label="決定" active="true"/>
          <sendButton v-else label="決定" active="false"/>
        </div>
      </div>
      <div v-else>
        <p>{{executer.name}}の<span v-on:click="showEffect(5)" class="plot-name"><b><u>責任者</u></b></span>の効果を処理しています。</p>
      </div>
    </div>
    </v-card>
  </div>
</template>

<script>
import pickButton from '@/components/gameUiComponents/PickedButton.vue'
import sendButton from '@/components/gameUiComponents/SendButton.vue'
export default {
  name: "responsibility",
  props: {isExecuter: Boolean, executer: Object},
  components: {
    pickButton,
    sendButton
  },
  data() {
    return {
      roomId: this.$store.state.gameInfo.roomId,
      userId: this.$store.state.userInfo.id,
      leader: this.$store.getters.leader,
      socket: this.$store.state.webSocket.socket,
      plotList: this.$store.state.userList.plotList,
      isAssigned: [],
      canSend: false,
      sent: false
    };
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users;
    },
    round () {
      return this.$store.state.missionInfo.round
    },
    isLeader: function() {
      return true
      // return this.$store.getters.isLeader;
    },

    getPlotName: function() {
      return (plotId) => this.$store.getters.getPlotName(plotId);
    },
    getUserName: function () {
      return (userId) => this.$store.getters.getUserById(userId).name;
    },
    haveResponsibility () {
      for (var i in this.users){
        if (this.users[i].id == this.userId){
          const plotCards = this.users[i].plots.filter(plot => plot.id == 5 && !plot.done)
          if (plotCards.length > 0){
            return true
          }
        }
      }
      return false
      // var haveLength = this.users.find(user => user.id == this.userId).plots.filter(plot => plot.id == 5)
      // if (haveLength>0){
      //   return true
      // }
      // return false
    }
  },
  methods: {
    assign(userIndex, plotIndex) {
      if (this.isAssigned[userIndex][plotIndex]){
        this.$set(this.isAssigned[userIndex], plotIndex, false)
        this.canSend = false
      }else {
        for (var i=0; i<this.users.length; i++){
          for (var j=0; j<this.users[i].plots.length; j++){
            this.$set(this.isAssigned[i], j, false)
          }
        }
        this.$set(this.isAssigned[userIndex], plotIndex, true)
        this.canSend = true
        // this.isAssigned[num] = true
        // this.previousSelect = num
      }
    },
    showEffect: function(id){
      this.$emit('send-effect', id)
    },
    push: function() {
      const selected = this.plotList[this.isAssigned.indexOf(true)]
      for (var i=0; i<this.users.length; i++){
        for (var j=0; j<this.users[i].plots.length; j++) {
          if (this.isAssigned[i][j]) {
            // this.sent = true
            this.$emit("execute-action", {"action": "execute-responsibility", "roomId": this.roomId, "userId": this.userId, data: {"responsibility": {"userId": this.users[i].id, "plotId": String(this.users[i].plots[j].id)}}})
            break
          }
        }
      }
      console.log(selected)
    }
  },
  created() {
    for (var i=0; i<this.users.length; i++){
      var _isAssigned = []
      for (var j=0; j<this.users[i].plots.length; j++) {
        _isAssigned.push(false)
      }
      this.isAssigned.push(_isAssigned)
    }
  }
};
</script>

<style>
#responsibility {
  /* background-color: rgb(253, 208, 208); */
}
#responsibility .send-button{
  padding-bottom: 12px
  /* display: inline-block; */
}
#responsibility .assigning-table {
 align-items: left;
 display: inline-block;
 text-align:center;
}
#responsibility td {
  font-size: 16px;
  border-bottom-width: 0px;
  background-color: #F6F6FA;
}
#responsibility .background-color {
  background-color: #F6F6FA;
}
#responsibility .assign-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #FFFFFF
}
#responsibility .invalid-button {
  margin-top: 4px;
  margin-bottom: 4px;
  background-color: #F6F6FA
}
#responsibility .plot-name {
  color: #5555BB;
  cursor:pointer;
}
</style>
